import { Currency, Form, Header } from '@mairistem/composants';

type SeuilProps = {
  value: number;
  header: string;
  disabled?: boolean;
  onSeuilChange: (e: any, value: number) => void;
};

const Seuil = (props: SeuilProps) => {
  const { header, value, onSeuilChange, disabled } = props;

  return (
    <>
      <Header as="h3">
        <Header.Content>
          {header}
          <Header.Subheader style={{ marginTop: '0.5em' }}>
            Seules les factures dont le reste à payer est supérieur ou égal au seuil seront
            éligibles.
          </Header.Subheader>
        </Header.Content>
      </Header>
      <Form.Field
        // @ts-expect-error
        style={{ display: 'flex', alignItems: 'center', columnGap: '0.5em' }}
      >
        <Currency
          data-testid="seuil"
          value={value}
          style={{ width: 100 }}
          valueMin={0}
          devise
          description=""
          onBlur={onSeuilChange}
          disabled={disabled}
        />
      </Form.Field>
    </>
  );
};

export default Seuil;
